export function createSignupModal(): string {
  return `
    <!-- iOS Release Signup Modal -->
    <div id="signup-modal" class="signup-modal" style="display: none;">
        <div class="signup-modal-overlay" id="signup-modal-overlay"></div>
        <div class="signup-modal-content">
            <div class="signup-modal-header">
                <button class="signup-modal-close" id="signup-modal-close" aria-label="Close signup form">
                    <svg viewBox="0 0 24 24" fill="currentColor">
                        <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/>
                    </svg>
                </button>
            </div>
            
            <div class="signup-modal-body">
                <!-- Success Message (initially hidden) -->
                <div id="signup-success-message" style="display: none; text-align: center; padding: 2rem 0;">
                    <div style="width: 64px; height: 64px; background: linear-gradient(135deg, #10b981, #059669); border-radius: 50%; margin: 0 auto 1.5rem; display: flex; align-items: center; justify-content: center; animation: successPulse 0.6s ease-out;">
                        <svg width="28" height="28" fill="white" viewBox="0 0 24 24">
                            <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/>
                        </svg>
                    </div>
                    <h3 style="color: #059669; font-size: 1.5rem; margin-bottom: 1rem; font-weight: 600;">You're on the list!</h3>
                    <p style="color: #64748b; font-size: 1rem; margin-bottom: 1rem;">We'll notify you when VibeChk relaunches.</p>
                    <div id="signup-countdown" style="color: #3b82f6; font-weight: 500; font-size: 0.95rem;"></div>
                </div>

                <!-- Signup Form -->
                <div id="signup-form-container">
                    <div class="signup-header">
                        <h2 class="signup-title">Sign up for Relaunch</h2>
                        <p class="signup-subtitle">Be the first to connect with creators when VibeChk relaunches, coming soon.</p>
                    </div>

                    <form id="signup-form" action="https://formspree.io/f/xzzgwrvg" method="POST">
                        <div class="signup-field">
                            <label for="signup-name" class="signup-label">Name</label>
                            <input 
                                type="text" 
                                id="signup-name" 
                                name="name" 
                                required 
                                class="signup-input"
                                placeholder="Your full name"
                            >
                        </div>

                        <div class="signup-field">
                            <label for="signup-email" class="signup-label">Email</label>
                            <input 
                                type="email" 
                                id="signup-email" 
                                name="email" 
                                required 
                                class="signup-input"
                                placeholder="your@email.com"
                            >
                        </div>

                        <div class="signup-field">
                            <label for="signup-role" class="signup-label">Creator Type</label>
                            <select 
                                id="signup-role" 
                                name="role" 
                                required 
                                class="signup-select"
                            >
                                <option value="">Select your role</option>
                                <option value="Founder">Founder</option>
                                <option value="Engineer">Engineer</option>
                                <option value="UI/UX Designer">UI/UX Designer</option>
                                <option value="Growth Hacker">Growth Hacker</option>
                                <option value="UGC Creator">UGC Creator</option>
                                <option value="VC/Angel">VC/Angel</option>
                                <option value="Artist">Artist</option>
                                <option value="Philosopher">Philosopher</option>
                            </select>
                        </div>

                        <div class="signup-field">
                            <label for="signup-social" class="signup-label">Social Link (Optional)</label>
                            <input 
                                type="url" 
                                id="signup-social" 
                                name="social_link" 
                                class="signup-input"
                                placeholder="Personal website, LinkedIn, or X profile"
                            >
                        </div>

                        <button type="submit" id="signup-submit" class="signup-submit-btn">
                            <span id="signup-btn-text">Join the Waitlist</span>
                            <span id="signup-btn-loading" style="display: none;">
                                <svg width="16" height="16" style="animation: spin 1s linear infinite; margin-right: 8px;" fill="white" viewBox="0 0 24 24">
                                    <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4" fill="none" opacity="0.25"/>
                                    <path fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"/>
                                </svg>
                                Signing up...
                            </span>
                        </button>
                    </form>
                </div>
            </div>
        </div>
    </div>

    <style>
        /* Signup Modal Styles */
        .signup-modal {
            position: fixed;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            z-index: 10000;
            display: flex;
            align-items: center;
            justify-content: center;
            opacity: 0;
            visibility: hidden;
            transition: all 0.3s ease;
        }

        .signup-modal.active {
            opacity: 1;
            visibility: visible;
        }

        .signup-modal-overlay {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background: rgba(0, 0, 0, 0.7);
            backdrop-filter: blur(8px);
        }

        .signup-modal-content {
            position: relative;
            background: white;
            border-radius: 16px;
            width: 90%;
            max-width: 480px;
            max-height: 90vh;
            overflow-y: auto;
            box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
            transform: translateY(30px) scale(0.95);
            transition: all 0.3s ease;
        }

        .signup-modal.active .signup-modal-content {
            transform: translateY(0) scale(1);
        }

        .signup-modal-header {
            position: relative;
            padding: 1rem;
        }

        .signup-modal-close {
            position: absolute;
            top: 1rem;
            right: 1rem;
            background: none;
            border: none;
            cursor: pointer;
            padding: 0.5rem;
            border-radius: 8px;
            transition: background-color 0.2s ease;
            width: 40px;
            height: 40px;
            display: flex;
            align-items: center;
            justify-content: center;
        }

        .signup-modal-close:hover {
            background: #f3f4f6;
        }

        .signup-modal-close svg {
            width: 20px;
            height: 20px;
        }

        .signup-modal-body {
            padding: 2rem;
        }

        .signup-header {
            text-align: center;
            margin-bottom: 2rem;
        }

        .signup-title {
            font-size: 1.75rem;
            font-weight: 700;
            color: #111827;
            margin-bottom: 0.5rem;
        }

        .signup-subtitle {
            color: #6b7280;
            font-size: 1rem;
            line-height: 1.5;
        }

        .signup-field {
            margin-bottom: 1.5rem;
        }

        .signup-label {
            display: block;
            font-weight: 500;
            color: #374151;
            margin-bottom: 0.5rem;
            font-size: 0.9rem;
            text-transform: uppercase;
            letter-spacing: 0.05em;
        }

        .signup-input,
        .signup-select {
            width: 100%;
            padding: 0.875rem;
            border: 1px solid #d1d5db;
            border-radius: 8px;
            font-size: 1rem;
            transition: all 0.2s ease;
            background: white;
            box-sizing: border-box;
        }

        .signup-select {
            appearance: none;
            background-image: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="%23666"><path d="M7 10l5 5 5-5z"/></svg>');
            background-repeat: no-repeat;
            background-position: right 0.75rem center;
            background-size: 1rem;
        }

        .signup-input:focus,
        .signup-select:focus {
            outline: none;
            border-color: #3b82f6;
            box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
        }

        .signup-submit-btn {
            width: 100%;
            background: linear-gradient(135deg, #000 0%, #2a2a2a 50%, #000 100%);
            color: white;
            padding: 1rem 2rem;
            border: none;
            border-radius: 8px;
            font-size: 1rem;
            font-weight: 600;
            cursor: pointer;
            transition: all 0.3s ease;
            position: relative;
            overflow: hidden;
            box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
        }

        .signup-submit-btn::before {
            content: '';
            position: absolute;
            top: 0;
            left: -100%;
            width: 100%;
            height: 100%;
            background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.1), transparent);
            transition: left 0.6s ease;
        }

        .signup-submit-btn:hover::before {
            left: 100%;
        }

        .signup-submit-btn:hover {
            transform: translateY(-2px);
            box-shadow: 0 8px 25px rgba(0, 0, 0, 0.3);
            background: linear-gradient(135deg, #1a1a1a 0%, #3a3a3a 50%, #1a1a1a 100%);
        }

        .signup-submit-btn:disabled {
            background: #9ca3af;
            cursor: not-allowed;
            transform: none;
            box-shadow: none;
        }

        .signup-submit-btn:disabled:hover {
            transform: none;
            box-shadow: none;
        }

        #signup-btn-loading {
            display: flex;
            align-items: center;
            justify-content: center;
        }

        @keyframes successPulse {
            0% { transform: scale(0.8); opacity: 0; }
            50% { transform: scale(1.05); opacity: 1; }
            100% { transform: scale(1); opacity: 1; }
        }

        @keyframes spin {
            from { transform: rotate(0deg); }
            to { transform: rotate(360deg); }
        }

        /* Mobile Responsiveness */
        @media (max-width: 640px) {
            .signup-modal-content {
                width: 95%;
                margin: 1rem;
            }

            .signup-modal-body {
                padding: 1.5rem;
            }

            .signup-title {
                font-size: 1.5rem;
            }
        }
    </style>


  `;
} 